import { useEffect } from 'react';

const Income = ({formData, setFormData}) => {

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
    };
    const handleIncomeTypes = (event) => {
        var checkboxes = document.getElementById('income_section').querySelectorAll('input[type=checkbox]');
        var checked = Array.from(checkboxes).filter(i => i.checked).map(i => i.value).join(',');
        setFormData((prevFormData) => ({ ...prevFormData, income_types: checked }));
    };

    useEffect(() => {
        const stateLimits = {
            AL: [14580,18310,23030,27750,32470,40300],
            AR: [20500,25268,31781,38295,44809,51322],
            AZ: [21000,28000,31781,38295,44809,51322],
            DE: [21000,25268,31781,38295,44809,51322],
            FL: [20100,18310,23030,27750,32470,37190],
            GA: [15000,18310,23030,27750,32470,37190],
            IA: [21000,25268,31781,38295,44809,51322],
            IL: [22000,25268,31781,38295,44809,51322],
            IN: [21000,25268,31781,38295,44809,51322],
            KS: [20500,18310,23030,27750,32470,37190],
            LA: [21000,28000,31781,38295,44809,51322],
            MI: [21000,25268,31781,38295,44809,51322],
            MO: [21000,25268,31781,38295,44809,51322],
            MS: [21000,18310,23030,27750,32470,37190],
            MT: [18754,25268,31781,38295,44809,51322],
            NC: [21000,18310,25000,27750,32470,37190],
            NE: [21000,25268,31781,38295,44809,51322],
            NH: [21000,25268,31781,38295,44809,51322],
            OH: [20500,28000,31781,38295,44809,51322],
            OK: [21000,25268,31781,38295,44809,51322],
            SC: [20000,18310,23030,27750,32470,37190],
            TN: [21000,18310,23030,27750,32470,37190],
            TX: [14580,19800,23030,27750,32470,37190],
            UT: [21000,25268,31781,38295,44809,51322],
            VA: [18754,25268,31781,38295,44809,51322],
            WI: [15000,18310,23030,27750,32470,37190],
            WV: [21000,25268,31781,38295,44809,51322]
        };
        
        if (formData.state !== '' && formData.total_income === -1) {
            let i = formData.how_many_others;
            if (i > 5) i = 5;
            var income = 21000;
            if (stateLimits[formData.state]) income = stateLimits[formData.state][i];
            setFormData((prevFormData) => ({ ...prevFormData, total_income: income }));
        }
    }, [setFormData, formData.state, formData.how_many_others, formData.total_income]);
    
    return (
        <div id="income_section" className="QuestionBox">
            <div className="QuestionBox">
                <label className="QuestionLabel" htmlFor="total_income">Estimated taxable income for all applicants who will be on your {formData.tax_year} tax filing:</label>
                <div>$<input className="IncomeInput" type="number" id="total_income" name="total_income" value={formData.total_income} onChange={handleChange} required/></div>
            </div>
            <div className="QuestionBox">
                <label className="QuestionLabel" htmlFor="income_type">Check all types of income that apply:</label>
                <div className="IncomeTypes">
                    <div>
                        <input type='checkbox' id='income_type_job' name='income_type_job' value='Job' checked={formData.income_types.includes('Job')} onChange={handleIncomeTypes}/>Job<br/>
                        <input type='checkbox' id='income_type_self_employed' name='income_type_self_employed' value='Self-employed' checked={formData.income_types.includes('Self-employed')} onChange={handleIncomeTypes}/>Self-employed<br/>
                        <input type='checkbox' id='income_type_unemployment' name='income_type_unemployment' value='Unemployment' checked={formData.income_types.includes('Unemployment')} onChange={handleIncomeTypes}/>Unemployment<br/>
                        <input type='checkbox' id='income_type_alimony' name='income_type_alimony' value='Alimony' checked={formData.income_types.includes('Alimony')} onChange={handleIncomeTypes}/>Alimony<br/>
                        <input type='checkbox' id='income_type_social_security' name='income_type_social_security' value='Social security' checked={formData.income_types.includes('Social security')} onChange={handleIncomeTypes}/>Social security<br/>
                        <input type='checkbox' id='income_type_retirement' name='income_type_retirement' value='Retirement' checked={formData.income_types.includes('Retirement')} onChange={handleIncomeTypes}/>Retirement<br/>
                    </div>
                    <div>
                        <input type='checkbox' id='income_type_pension' name='income_type_pension' value='Pension' checked={formData.income_types.includes('Pension')} onChange={handleIncomeTypes}/>Pension<br/>
                        <input type='checkbox' id='income_type_cash_support' name='income_type_cash_support' value='Cash support' checked={formData.income_types.includes('Cash support')} onChange={handleIncomeTypes}/>Cash support<br/>
                        <input type='checkbox' id='income_type_capital_gains' name='income_type_capital_gains' value='Capital gains' checked={formData.income_types.includes('Capital gains')} onChange={handleIncomeTypes}/>Capital gains<br/>
                        <input type='checkbox' id='income_type_investment' name='income_type_investment' value='Investment' checked={formData.income_types.includes('Investment')} onChange={handleIncomeTypes}/>Investment<br/>
                        <input type='checkbox' id='income_type_rental_royalty' name='income_type_rental_royalty' value='Rental/royalty' checked={formData.income_types.includes('Rental/royalty')} onChange={handleIncomeTypes}/>Rental/royalty<br/>
                        <input type='checkbox' id='income_type_scholarship' name='income_type_scholarship' value='Scholarship' checked={formData.income_types.includes('Scholarship')} onChange={handleIncomeTypes}/>Scholarship<br/>
                    </div>
                    <div>
                        <input type='checkbox' id='income_type_prize_award' name='income_type_prize_award' value='Prize award' checked={formData.income_types.includes('Prize award')} onChange={handleIncomeTypes}/>Prize award<br/>
                        <input type='checkbox' id='income_type_court_award' name='income_type_court_award' value='Court award' checked={formData.income_types.includes('Court award')} onChange={handleIncomeTypes}/>Court award<br/>
                        <input type='checkbox' id='income_type_jury_pay' name='income_type_jury_pay' value='Jury pay' checked={formData.income_types.includes('Jury pay')} onChange={handleIncomeTypes}/>Jury pay<br/>
                        <input type='checkbox' id='income_type_other' name='income_type_other' value='Other' checked={formData.income_types.includes('Other')} onChange={handleIncomeTypes}/>Other<br/>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Income;